import ExternalLinksBaseHandler from '../external_links_base_handler';
import _ from '../../../../utils/underscore';
import {MY_ACCOUNT_POST_ACTIONS} from '../my_account/external_links_my_account_handler_consts';

class ExternalLinksDocumentUploadHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksDocumentUploadHandler';
    static HandlerName = 'upload_document';

    /**
     * Overrides base class
     * @param postMessageData
     */
    executePostMessageAction(postMessageData) {
        let postDataObjLower = _.toLowerCaseKeys(postMessageData);
        switch (postDataObjLower.actionid.toString()) {
            case MY_ACCOUNT_POST_ACTIONS.CLOSE:
                this.close();
                break;
            default:
                this.logger.warn('Not supported ActionID. ActionID = ' + postDataObjLower.actionid);
                break;
        }
    }
    getHandlerName() {
        return ExternalLinksDocumentUploadHandler.HandlerName;
    }
}

export default ExternalLinksDocumentUploadHandler;